import * as actionTypes from "./ActionTypes";

export const getOrgsOfAdminAction = (data) => {
  return { type: actionTypes.GET_ORGS_OF_ADMIN, data };
};
export const getOrgsOfAdminSuccessAction = (res) => {
  return { type: actionTypes.GET_ORGS_OF_ADMIN_SUCCESS, res };
};
export const getOrgsOfAdminFailAction = (error) => {
  return { type: actionTypes.GET_ORGS_OF_ADMIN_FAIL, error };
};

export const setAdminAction = (data) => {
  return { type: actionTypes.SET_ADMIN, data };
};
export const setAdminSuccessAction = (res) => {
  return { type: actionTypes.SET_ADMIN_SUCCESS, res };
};
export const setAdminFailAction = (error) => {
  return { type: actionTypes.SET_ADMIN_FAIL, error };
};

export const changeShowDialogsAction = (key, value) => {
  return { type: actionTypes.CHANGE_SHOW_DIALOGS, key, value };
};

export const clearStateAction = (state) => {
  return { type: actionTypes.CLEAR_STATE, state };
};

export const SearchOrgsAction = (data) => {
  return { type: actionTypes.SET_SEARCHED_ORGS, data };
};

export const getOrganizationAction = (data, getAll = false) => {
  return { type: actionTypes.GET_ORGANIZATION, data, getAll };
};
export const getOrganizationSuccessAction = (res, getAll) => {
  return { type: actionTypes.GET_ORGANIZATION_SUCCESS, res, getAll };
};
export const getOrganizationFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_FAIL, error };
};

export const getAllTenantsAction = (data) => {
  return { type: actionTypes.GET_ALL_TENANTS, data };
};
export const getAllTenantsSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_TENANTS_SUCCESS, res };
};
export const getAllTenantsFailAction = (error) => {
  return { type: actionTypes.GET_ALL_TENANTS_FAIL, error };
};

export const addOrgAction = (data) => {
  return { type: actionTypes.ADD_ORGANIZATION, data };
};
export const addOrgSuccessAction = (res) => {
  return { type: actionTypes.ADD_ORGANIZATION_SUCCESS, res };
};
export const addOrgFailAction = (error) => {
  return { type: actionTypes.ADD_ORGANIZATION_FAIL, error };
};

export const addTenantAction = (data) => {
  return { type: actionTypes.ADD_TENANT, data };
};
export const addTenantSuccessAction = (res) => {
  return { type: actionTypes.ADD_TENANT_SUCCESS, res };
};
export const addTenantFailAction = (error) => {
  return { type: actionTypes.ADD_TENANT_FAIL, error };
};

export const editTenantAction = (data) => {
  return { type: actionTypes.EDIT_TENANT, data };
};
export const editTenantSuccessAction = (res) => {
  return { type: actionTypes.EDIT_TENANT_SUCCESS, res };
};
export const editTenantFailAction = (error) => {
  return { type: actionTypes.EDIT_TENANT_FAIL, error };
};

export const editOrgAction = (data) => {
  return { type: actionTypes.EDIT_ORGANIZATION, data };
};
export const editOrgSuccessAction = (res) => {
  return { type: actionTypes.EDIT_ORGANIZATION_SUCCESS, res };
};
export const editOrgFailAction = (error) => {
  return { type: actionTypes.EDIT_ORGANIZATION_FAIL, error };
};

export const getOrgByIdAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATION_BY_ID, data };
};
export const getOrgByIdSuccessAction = (res) => {
  return { type: actionTypes.GET_ORGANIZATION_BY_ID_SUCCESS, res };
};
export const getOrgByIdFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_BY_ID_FAIL, error };
};

export const changeOrgActivationAction = (data) => {
  return { type: actionTypes.CHANGE_ORGANIZATION_ACTIVATION, data };
};
export const changeOrgActivationSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_ORGANIZATION_ACTIVATION_SUCCESS, res };
};
export const changeOrgActivationFailAction = (error) => {
  return { type: actionTypes.CHANGE_ORGANIZATION_ACTIVATION_FAIL, error };
};

export const changeTenantActivationAction = (data) => {
  return { type: actionTypes.CHANGE_TENANT_ACTIVATION, data };
};
export const changeTenantActivationSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_TENANT_ACTIVATION_SUCCESS, res };
};
export const changeTenantActivationFailAction = (error) => {
  return { type: actionTypes.CHANGE_TENANT_ACTIVATION_FAIL, error };
};

export const deleteTenantAction = (data) => {
  return { type: actionTypes.DELETE_TENANT, data };
};
export const deleteTenantSuccessAction = (res) => {
  return { type: actionTypes.DELETE_TENANT_SUCCESS, res };
};
export const deleteTenantFailAction = (error) => {
  return { type: actionTypes.DELETE_TENANT_FAIL, error };
};

export const getTenantByIdAction = (data) => {
  return { type: actionTypes.GET_TENANT_BY_ID, data };
};
export const getTenantByIdSuccessAction = (res) => {
  return { type: actionTypes.GET_TENANT_BY_ID_SUCCESS, res };
};
export const getTenantByIdFailAction = (error) => {
  return { type: actionTypes.GET_TENANT_BY_ID_FAIL, error };
};

export const getOrganizationUserAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATION_USER, data };
};
export const getOrganizationUserSuccessAction = (res) => {
  return { type: actionTypes.GET_ORGANIZATION_USER_SUCCESS, res };
};
export const getOrganizationUserFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_USER_FAIL, error };
};

export const getTenantUserAction = (data) => {
  return { type: actionTypes.GET_TENANT_USER, data };
};
export const getTenantUserSuccessAction = (res) => {
  return { type: actionTypes.GET_TENANT_USER_SUCCESS, res };
};
export const getTenantUserFailAction = (error) => {
  return { type: actionTypes.GET_TENANT_USER_FAIL, error };
};

export const updateOrgUserAction = (data) => {
  return { type: actionTypes.UPDATE_ORGANIZATION_USER, data };
};
export const updateOrgUserSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_ORGANIZATION_USER_SUCCESS, res };
};
export const updateOrgUserFailAction = (error) => {
  return { type: actionTypes.UPDATE_ORGANIZATION_USER_FAIL, error };
};

export const updateTenantUserAction = (data) => {
  return { type: actionTypes.UPDATE_TENANT_USER, data };
};
export const updateTenantUserSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_TENANT_USER_SUCCESS, res };
};
export const updateTenantUserFailAction = (error) => {
  return { type: actionTypes.UPDATE_TENANT_USER_FAIL, error };
};

export const changeOrganizationPasswordAction = (data) => {
  return { type: actionTypes.CHANGE_ORG_PASSWORD, data };
};
export const changeOrganizationPasswordSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_ORG_PASSWORD_SUCCESS, res };
};
export const changeOrganizationPasswordFailAction = (error) => {
  return { type: actionTypes.CHANGE_ORG_PASSWORD_FAIL, error };
};

export const changeTenantPasswordAction = (data) => {
  return { type: actionTypes.CHANGE_TENANT_PASSWORD, data };
};
export const changeTenantPasswordSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_TENANT_PASSWORD_SUCCESS, res };
};
export const changeTenantPasswordFailAction = (error) => {
  return { type: actionTypes.CHANGE_TENANT_PASSWORD_FAIL, error };
};

export const getUserTokenAction = (data) => {
  return { type: actionTypes.GET_USER_TOKEN, data };
};
export const getUserTokenSuccessAction = (res) => {
  return { type: actionTypes.GET_USER_TOKEN_SUCCESS, res };
};
export const getUserTokenFailAction = (error) => {
  return { type: actionTypes.GET_USER_TOKEN_FAIL, error };
};

export const getUserTokenByTenantIdAction = (data) => {
  return { type: actionTypes.GET_USER_TOKEN_BY_TENANT_ID, data };
};

export const getOrganizationUsageAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATION_USAGE, data };
};
export const getOrganizationUsageSuccessAction = (res, interval) => {
  return { type: actionTypes.GET_ORGANIZATION_USAGE_SUCCESS, res, interval };
};
export const getOrganizationUsageFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_USAGE_FAIL, error };
};

export const getOrganizationsUsageAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATIONS_USAGE, data };
};
export const getOrganizationsUsageSuccessAction = (res, interval) => {
  return { type: actionTypes.GET_ORGANIZATIONS_USAGE_SUCCESS, res, interval };
};
export const getOrganizationsUsageFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATIONS_USAGE_FAIL, error };
};

export const downloadUsageAction = (data) => {
  return { type: actionTypes.DOWNLOAD_USAGE, data };
};
export const downloadUsageSuccessAction = (res) => {
  return { type: actionTypes.DOWNLOAD_USAGE_SUCCESS, res };
};
export const downloadUsageFailAction = (error) => {
  return { type: actionTypes.DOWNLOAD_USAGE_FAIL, error };
};

export const getOrgPOCAction = (data) => {
  return { type: actionTypes.GET_ORG_POC, data };
};
export const getOrgPOCSuccessAction = (res) => {
  return { type: actionTypes.GET_ORG_POC_SUCCESS, res };
};
export const getOrgPOCFailAction = (error) => {
  return { type: actionTypes.GET_ORG_POC_FAIL, error };
};

export const updateOrgPOCAction = (data) => {
  return { type: actionTypes.UPDATE_ORG_POC, data };
};
export const updateOrgPOCSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_ORG_POC_SUCCESS, res };
};
export const updateOrgPOCFailAction = (error) => {
  return { type: actionTypes.UPDATE_ORG_POC_FAIL, error };
};

export const addOrgPOCTypeAction = (data) => {
  return { type: actionTypes.ADD_ORG_POC, data };
};
export const addOrgPOCTypeSuccessAction = (res) => {
  return { type: actionTypes.ADD_ORG_POC_SUCCESS, res };
};
export const addOrgPOCTypeFailAction = (error) => {
  return { type: actionTypes.ADD_ORG_POC_FAIL, error };
};

export const removeOrgPOCTypeAction = (data) => {
  return { type: actionTypes.REMOVE_ORG_POC, data };
};
export const removeOrgPOCTypeSuccessAction = (res) => {
  return { type: actionTypes.REMOVE_ORG_POC_SUCCESS, res };
};
export const removeOrgPOCTypeFailAction = (error) => {
  return { type: actionTypes.REMOVE_ORG_POC_FAIL, error };
};

export const getOrganizationAdminAction = (data) => {
  return { type: actionTypes.GET_ORG_ADMINS, data };
};
export const getOrganizationAdminSuccessAction = (res) => {
  return { type: actionTypes.GET_ORG_ADMINS_SUCCESS, res };
};
export const getOrganizationAdminFailAction = (error) => {
  return { type: actionTypes.GET_ORG_ADMINS_FAIL, error };
};

export const addOrgAdminAction = (data) => {
  return { type: actionTypes.ADD_ORG_ADMIN, data };
};
export const addOrgAdminSuccessAction = (res) => {
  return { type: actionTypes.ADD_ORG_ADMIN_SUCCESS, res };
};
export const addOrgAdminFailAction = (error) => {
  return { type: actionTypes.ADD_ORG_ADMIN_FAIL, error };
};
